import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import {Button, ButtonToolbar, Modal, Col, Row, Card, CardBody, Container} from 'reactstrap';
import {connect} from "react-redux";
import {withRouter} from "react-router-dom";
import {fetchTasksDataIfNeeded} from "../redux/actions/TasksActions";
import TasksTable from "../pages/tasks/Tasks";




class ModalTasks extends PureComponent {
    static propTypes = {
        title: PropTypes.string,
        message: PropTypes.string,
        color: PropTypes.string.isRequired,
        colored: PropTypes.bool,
        header: PropTypes.bool
    };

    constructor(props) {
        super(props);
        this.state = {
            modal: false,
            warning: '',
            errorText: ''
        };
    }

    componentDidMount() {
        this.props.dispatch(fetchTasksDataIfNeeded(true));
    }

    toggle = () => {
        this.setState({
            modal: !this.state.modal
        });
    };

    render() {
        let data = this.props.data;

        let Icon;

        switch (this.props.color) {
            case 'primary':
                Icon = <span className='lnr lnr-pushpin modal__title-icon'/>;
                break;
            case 'success':
                Icon = <span className='lnr lnr-thumbs-up modal__title-icon'/>;
                break;
            case 'warning':
                Icon = <span className='lnr lnr-flag modal__title-icon'/>;
                break;
            case 'danger':
                Icon = <span className='lnr lnr-cross-circle modal__title-icon'/>;
                break;
            default:
                break;
        }

        return (
            <div onClick={this.toggle}>
                {this.props.children}
                <Modal isOpen={this.state.modal} toggle={this.toggle} style={{maxWidth: '800px', width: '800px'}}
                       className={`modal-dialog--${this.props.color} ${this.props.colored ? 'modal-dialog--colored' : ''} ${this.props.header ? 'modal-dialog--header' : ''}`}>
                    <div className='modal__header'>
                        <span className='lnr lnr-cross modal__close-btn' onClick={this.toggle}/>
                        {this.props.header ? '' : Icon}
                        <h4 className='bold-text  modal__title'>{this.props.title}</h4>
                    </div>
                    <div className='modal__body'>
                        <Container className='dashboard'>
                            <Row>
                                <TasksTable data={data}/>
                            </Row>
                        </Container>
                    </div>
                    <ButtonToolbar className='modal__footer'>
                        <Button onClick={this.toggle}>Close</Button>{' '}
                    </ButtonToolbar>
                </Modal>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        userData: state.userData,
        utilsData: state.utilsData,
        data: state.tasks.data
    };
};

export default withRouter(connect(mapStateToProps)(ModalTasks))